export default __webpack_public_path__ + "static/media/Snd_W_Starts.01402866.mp3";